import { TakenSubdomainTypeEnum } from '@zaoblako/shared/modules/saas/enums/taken-subdomain-type.enum';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations for {@link TakenSubdomainTypeEnum} enumeration values */
export const TakenSubdomainTypeEnumI18n: EnumI18nInterface<TakenSubdomainTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [TakenSubdomainTypeEnum.MAIN]: 'Основной домен для основного режима',
    [TakenSubdomainTypeEnum.ALIAS]: 'Резерный домен для основного режима',
    [TakenSubdomainTypeEnum.PERSONAL_ACCOUNT]: 'Основной домен для режима ЛК',
    [TakenSubdomainTypeEnum.PERSONAL_ACCOUNT_ALIAS]: 'Резервный домен для режима ЛК',
  },
  [I18nLocalesEnum.EN_US]: {
    [TakenSubdomainTypeEnum.MAIN]: 'Primary domain for tenant mode',
    [TakenSubdomainTypeEnum.ALIAS]: 'Alias domain for tenant mode',
    [TakenSubdomainTypeEnum.PERSONAL_ACCOUNT]: 'Primary domain for personal account mode',
    [TakenSubdomainTypeEnum.PERSONAL_ACCOUNT_ALIAS]: 'Alias domain for personal account mode',
  },
};
